import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "../lib/api";

const WINES = [
  {
    id: "delta-red",
    name: "Delta Red",
    notes: "Black cherry, sage, fine tannins",
    meta: "Estate Red · Cellar 5+ Years",
    img: "https://images.unsplash.com/photo-1553361371-9b22f78e8b1d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "breeze-blanc",
    name: "Breeze Blanc",
    notes: "Citrus blossom, wet stone, bright acidity",
    meta: "Barrel-Fermented White",
    img: "https://images.unsplash.com/photo-1777008685591-d844ee174260?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "grenache-rose",
    name: "Grenache Rosé",
    notes: "Wild strawberry, white pepper, dry finish",
    meta: "Patio Staple · Serve Chilled",
    img: "https://images.unsplash.com/photo-1547595628-c61a29f496f0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "estate-blend",
    name: "Estate Red Blend",
    notes: "Structured, dark fruit, long finish",
    meta: "Flagship · Limited Cases",
    img: "https://images.unsplash.com/photo-1765850257843-aa029ab7769c?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "barrel-white",
    name: "Barrel-Fermented White",
    notes: "Aromatic, mineral-driven, food-friendly",
    meta: "Small Lot · 200 Cases",
    img: "https://images.unsplash.com/photo-1764709124945-56ba2ae2c496?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

const WineCard = ({ wine, index }) => (
  <Reveal delay={index * 0.08}>
    <div
      data-testid={`wine-card-${wine.id}`}
      className="spotlight-card group bg-[#141210] border border-[rgba(212,175,55,0.15)] hover:border-[rgba(212,175,55,0.45)] transition-colors duration-500 hover:-translate-y-2 transform-gpu transition-transform"
    >
      <div className="relative overflow-hidden aspect-[3/4]">
        <img
          src={wine.img}
          alt={wine.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0908]/85 via-transparent to-transparent" />
        <p className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
          {String(index + 1).padStart(2, "0")}
        </p>
      </div>
      <div className="p-6">
        <h3 className="font-serif-display text-2xl font-light text-[#F4F1EA]">{wine.name}</h3>
        <p className="text-sm text-[#A39E93] mt-2 leading-relaxed">{wine.notes}</p>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-[rgba(212,175,55,0.12)]">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E685E]">{wine.meta}</span>
          <button
            data-testid={`wine-tasting-${wine.id}`}
            onClick={() => scrollToId("visit")}
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] hover:text-[#F4F1EA] transition-colors"
          >
            Taste It
          </button>
        </div>
      </div>
    </div>
  </Reveal>
);

export const Wines = () => (
  <section id="wines" data-testid="wines-section" className="relative py-28 lg:py-40 bg-[#0A0908]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16 lg:mb-24">
        <SectionHeading overline="The Collection" title="This season, in the glass." />
        <Reveal delay={0.2}>
          <p className="text-sm text-[#6E685E] max-w-xs leading-relaxed">
            Highlights from the tasting menu. Confirm vintage availability before you visit — small lots move quickly.
          </p>
        </Reveal>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {WINES.slice(0, 3).map((w, i) => (
          <WineCard key={w.id} wine={w} index={i} />
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-6 lg:gap-8 mt-6 lg:mt-8 lg:max-w-[66%] lg:mx-auto">
        {WINES.slice(3).map((w, i) => (
          <WineCard key={w.id} wine={w} index={i + 3} />
        ))}
      </div>
    </div>
  </section>
);
